import { ESocialMedia } from "@Cores/enums";
import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import z from "zod";
import { EntityExtraDto, EntityResponseDto } from "./entity-dto";
import { EventResponseDto } from "./event-dto";
// Get
export interface VenueResponseDto extends IEntityWithSoftDeleteDto {
    id: string;
    name: string;
    capacity: number;
    priceType: string;
    price: number;
    priceIncluded: boolean;
    remarks: string;
    address: string;
    entityId: string;
    entity?: EntityResponseDto;
    availabilitySchedule: AvailableScheduleDto[];
    extras: VenueExtraDto[];
    images: VenueImageDto[];
    events: EventResponseDto[];
}

export interface VenueExtraDto {
    id: string;
    venueId: string;
    entityExtraId: string;
    entityExtra: EntityExtraDto;

    description: string;
    priceIncluded: boolean;
    isRequired: boolean;
    createdAt: string;
}

export const availableScheduleSchema = z.object({
    date: z.string(),
});

// zod schema
export const venueExtraFormSchema = z.object({
    id: z.string().optional(),
    name: z.string(),
    price: z.string(),
    isRequired: z.boolean().optional(),
    priceIncluded: z.boolean().optional(),
    description: z.string(),
    images: z.array(z.instanceof(File)).optional(),
});

export const venueExtraSchema = z.object({
    id: z.string().optional(),
    name: z.string(),
    price: z.string(),
    description: z.string(),
});

// zod schema
export const venueFormSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(3, { message: "Name must be at least 3 characters." }),
    capacity: z.string().refine(val => !isNaN(Number(val)), { message: "Capacity must be a number" }),
    priceType: z.string(),
    price: z.string().refine(val => !isNaN(Number(val)), { message: "Price must be a number" }),
    priceIncluded: z.boolean().optional(),
    entityId: z.string().optional(),
    address: z.string(),
    remarks: z.string(),
    images: z.array(z.instanceof(File)).optional(),
    extras: z.array(venueExtraSchema).optional(),
    availabilitySchedule: z.array(availableScheduleSchema).optional(),
});

// zod infer
export type VenueFormDto = z.infer<typeof venueFormSchema>;

export type VenueExtraFormDto = z.infer<typeof venueExtraFormSchema>;

export type AvailableScheduleDto = z.infer<typeof availableScheduleSchema>;

export interface SocialMediaDTo {
    type?: ESocialMedia;
    link?: string;
}

// zod schema

export const socialMediaSchema = z.object({
    type: z.nativeEnum(ESocialMedia),
    link: z.string(),
});

export type SocialMediaDto = z.infer<typeof socialMediaSchema>;

export const venueImageSchema = z.object({
    Path: z.string(),
});

export type VenueImageDto = z.infer<typeof venueImageSchema>;